// Popup.js
import React from "react";
import "./popup.css"; // Ensure you have some basic styling for the popup

const Popup = ({ header, message1, message2, onClose, close }) => {
  return (
    <div className="popup_overlay">
      <div className="popup_content">
        <div onClick={onClose} className="close">
          x
        </div>
        <h3>{header}</h3>
        <p>{message1}</p>
        <br></br>
        <p>{message2}</p>
        <button onClick={onClose}>{close}</button>
      </div>
    </div>
  );
};

export default Popup;
